import { FETCH_PERMISSIONS, RESET_INITIAL_DATA } from 'actions/types';

const INITIAL_STATE = {
  permissions: {},
  loaded: false,
};

const permissionReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PERMISSIONS: {
      const updatedState = { permissions: {} };
      action.payload.forEach((permission) => {
        updatedState.permissions[permission.permission_name] = {
          ...permission,
        };
      });
      return { ...state, ...updatedState, loaded: true };
    }
    case RESET_INITIAL_DATA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default permissionReducer;
